import { render, staticRenderFns } from "./PractitionersApplications.vue?vue&type=template&id=03388a8a&scoped=true&"
import script from "./PractitionersApplications.vue?vue&type=script&lang=js&"
export * from "./PractitionersApplications.vue?vue&type=script&lang=js&"
import style0 from "./PractitionersApplications.vue?vue&type=style&index=0&id=03388a8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03388a8a",
  null
  
)

export default component.exports